import { useEffect, useState } from 'react';
import { Large } from '../styles/bootstrap-breakpoints';
import { ViewType } from '../model/view-type';

export function useViewType(): ViewType {
    const [viewType, setViewType] = useState<ViewType>(() =>
        window.innerWidth >= Large ? 'desktop' : 'mobile'
    );

    useEffect(() => {
        const updateViewType = () => {
            const newViewType: ViewType = window.innerWidth >= Large ? 'desktop' : 'mobile';
            setViewType(newViewType);
        };

        window.addEventListener('resize', updateViewType);
        return () => window.removeEventListener('resize', updateViewType);
    }, []);

    return viewType;
}
